define('sentient/aba/views/TouchView',[
    'jquery',
    'underscore',
    'backbone',
    'loglevel',
    '../app'
], function($, _, Backbone, log, app) {
    log.trace('ExerciseView.js');
    var TouchView = Backbone.View.extend({
        passThrough: false,
        debug: false,
        id: 'touch-input-capture',
        touches: {},
        initialize: function() {
            this.$el.css({
                'position': 'absolute',
                'top': 0,
                'left': 0,
                'width': '100%',
                'height': '100%'
            });
            if (this.debug) {
                this.canvas = document.createElement('CANVAS');
                this.$canvas = $(this.canvas);

                this.$canvas.css({
                    'width': '100%',
                    'height': '100%',
                    'position': 'absolute',
                    'top': 0,
                    'left': 0
                });
                this.$el.before(this.$canvas);
                this.$canvas.attr({
                    width: this.$canvas.width(),
                    height: this.$canvas.height()
                });

            }
        },
        render: function() {},
        events: {
            'touchstart': 'touchstart',
            'touchend': 'touchend',
            'touchcancel': 'touchcancel',
            'touchleave': 'touchleave',
            'touchmove': 'touchmove'
        },
        'touchstart': function(backboneEvent) {
            if (this.passThrough) {
                return true;
            }
            //log.debug("TouchView::touchstart",this);
            var $event = backboneEvent.originalEvent;
            var timeStamp = $event.timeStamp;
            var verticalThreshold = (this.resolution['vertical']['px/cm']) * 1.5;
            _($event.changedTouches).each(function(touch, touchIndex, touchList) {
                if (typeof(this.touches[touch.identifier]) == 'undefined') {
                    this.touches[touch.identifier] = {
                        'touchMove': []
                    };
                }
                var trackedTouch = this.touches[touch.identifier];
                //log.debug("trackedTouch Start",touch);
                trackedTouch = _.extend(trackedTouch, {
                    'touchStartTimeStamp': timeStamp,
                    'touchStartX': touch.pageX,
                    'touchStartY': touch.pageY,
                    'swipeUpThreshold': touch.pageY - verticalThreshold,
                    'swipeDownThreshold': touch.pageY + verticalThreshold
                });
                if (this.canvas) {
                    var ctx = this.canvas.getContext('2d');
                    ctx.strokeStyle = 'rgba(255,255,255,1)';
                    ctx.lineWidth = 1;
                    ctx.beginPath();
                    //ctx.arc(touch.pageX,touch.pageY,this.resolution["horizontal"]["px/cm"] * 1,0,2*Math.PI);
                    ctx.moveTo(0, touch.pageY + this.resolution['horizontal']['px/cm']);
                    ctx.lineTo(this.canvas.width, touch.pageY + this.resolution['horizontal']['px/cm']);
                    ctx.moveTo(0, touch.pageY - this.resolution['horizontal']['px/cm']);
                    ctx.lineTo(this.canvas.width, touch.pageY - this.resolution['horizontal']['px/cm']);
                    ctx.stroke();
                }
            }, this);
            $event.preventDefault();
            return false;
        },
        'touchend': function(backboneEvent) {
            if (this.passThrough) {
                return true;
            }
            //log.debug("TouchView::touchend",$event,this);
            var $event = backboneEvent.originalEvent;
            var timeStamp = $event.timeStamp;
            _($event.changedTouches).each(function(touch, touchIndex, touchList) {
                //this.touches[touch.identifier] = _.extend(this.touches[touch.identifier],{"touchStartTimeStamp":timeStamp});
                if (typeof(this.touches[touch.identifier]) != 'undefined') {
                    var trackedTouch = this.touches[touch.identifier];
                    trackedTouch = _.extend(trackedTouch, {
                        'touchEndTimeStamp': timeStamp,
                        'touchEndX': touch.pageX,
                        'touchEndY': touch.pageY
                    });
                    //log.debug("TouchView::touchend trackedTouch",timeStamp - trackedTouch.touchStartTimeStamp );
                    //log.debug("touchEnd",trackedTouch);
                    if (touch.pageY < trackedTouch['swipeUpThreshold']) {
                        this.trigger('swipeup', trackedTouch);
                        //log.debug("swipeup",trackedTouch);
                        delete this.touches[touch.identifier];
                    }
                    if (touch.pageY > trackedTouch['swipeDownThreshold']) {
                        this.trigger('swipedown', trackedTouch);
                        //log.debug("swipedown",trackedTouch);
                        delete this.touches[touch.identifier];
                    }
                    delete this.touches[touch.identifier];
                }
            }, this);
            if (this.canvas) {
                var ctx = this.canvas.getContext('2d');
                ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
            }
            $event.preventDefault();
            return false;
        },
        'touchcancel': function(backboneEvent) {
            if (this.debug && app.windowCanvasView) {
                app.windowCanvasView.drawTouchCircle();
            }
            if (this.passThrough) {
                return true;
            }
            //log.debug("TouchView::touchcancel",$event,this);
            var $event = backboneEvent.originalEvent;
            $event.preventDefault();
            return false;
        },
        'touchleave': function(backboneEvent) {
            if (this.debug && app.windowCanvasView) {
                app.windowCanvasView.drawTouchCircle();
            }
            if (this.passThrough) {
                return true;
            }
            //log.debug("TouchView::touchleave",$event,this);
            var $event = backboneEvent.originalEvent;
            $event.preventDefault();
            return false;
        },
        'touchmove': function(backboneEvent) {
            if (this.passThrough) {
                return true;
            }
            var $event = backboneEvent.originalEvent;
            var timeStamp = $event.timeStamp;
            //log.debug("TouchView::touchmove",$event,this);
            _($event.changedTouches).each(function(touch, touchIndex, touchList) {
                //this.touches[touch.identifier] = _.extend(this.touches[touch.identifier],{"touchStartTimeStamp":timeStamp});
                if (typeof(this.touches[touch.identifier]) != 'undefined') {
                    var trackedTouch = this.touches[touch.identifier];

                    trackedTouch['touchMove'].push({
                        'timeStamp': timeStamp,
                        'X': touch.pageX,
                        'Y': touch.pageY
                    });
                    if (touch.pageY < trackedTouch['swipeUpThreshold']) {
                        //log.debug(" TouchView swipedown",trackedTouch);
                        this.trigger('swipeup', trackedTouch);
                        delete this.touches[touch.identifier];
                    }
                    if (touch.pageY > trackedTouch['swipeDownThreshold']) {
                        //log.debug(" TouchView swipedown",trackedTouch);
                        this.trigger('swipedown', trackedTouch);
                        delete this.touches[touch.identifier];
                    }
                    //log.debug("touchLastMoved",trackedTouch);
                }
            }, this);
            $event.preventDefault();
            return false;
        }
    });
    return TouchView;
});
